import React from "react";
import { motion } from "framer-motion";
import "./ContactSection.css";
import ContactImage from "../assets/image/imageContact.avif"

function ContactSection() {
  return (
    <div className="box-contact" id="comienza">
      <motion.div
        className="contact"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <motion.div
          className="text-contact"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          <div className="content-text-contact">
            <h2 className="section-title" style={{ color: "white" }} >Comienza con nosotros</h2>
            <p className="section-text-contact">
              ¿Listo para llevar tu logística al siguiente nivel? <br></br>
              {/* <a href="mailto:info@conexs.com">info@conexs.com</a> | +123 456 7890 */}
            </p>
          </div>
          <div className="cta-buttons">
            <a href="https://service.conexs.app" target="_blank" className="btn btn-primary-contact section-text">
              Reservar Ahora
            </a>
            <a href="https://business.conexs.app" target="_blank" className="btn btn-secondary-contact section-text">
              Regístrate como Empresa
            </a>
          </div>
        </motion.div>
        <img src={ContactImage} className="contact-image" alt="contact-image"></img>
      </motion.div>
    </div>
  );
}

export default ContactSection;
